export default {
    setShowSavedDataFlag(state, flag) {
        state.showSavedData = flag
    },
    setShowErrorModal(state, flag) {
        state.showErrorModal = flag
    },
    setShowLoadingModal(state, flag) {
        state.showLoadingModal = flag
    },
    setShowDisclaimerModal(state, flag) {
        state.showDisclaimerModal = flag
    },
    setShowNoDiagnoseFoundModal(state, flag) {
        state.showNoDiagnoseFoundModal = flag
    },
    setPatient(state, patient) {
        state.patient = patient
    },
    setAnfallsanamnese(state, anfallsanamnese) {
        state.anfallsanamnese = anfallsanamnese
    },
    setTechnischeUntersuchungen(state, technischeUntersuchungen) {
        state.technischeUntersuchungen = technischeUntersuchungen
    },
    setDiagnosestellung(state, diagnosestellung) {
        state.diagnosestellung = diagnosestellung
    },
    setTherapie(state, therapie) {
        state.therapie = therapie
    },
    setTherapieReachable(state, therapieReachableFlag) {
        state.therapieReachable = therapieReachableFlag
    },
    setDiagnosestellungReachable(state, diagnoseStellungReachableFlag) {
        state.diagnosestellungReachable = diagnoseStellungReachableFlag
    },
    setActionToRetry(state, action){
        state.actionToRetry = action
    },
    setShowAnfaelleOverview(state, flag){
        state.showAnfaelleOverview = flag
    },
    setShowUntersuchungenOverview(state, flag){
        state.showUntersuchungenOverview = flag
    }
}